import './NTAI.css';
import img from '../../../resources/Group 1000003421 (2).png'
import ntai from '../../../resources/ntai_icon.png'

function NTAI() {
    return (
        <div className='all_margin'>
            <div className='margin_auto_width'>
                <div className='ntai_main_div padding_top padding_bottom'>
                    <div>
                        <div className='flex align_center gap_8'>
                            <p className='green_gradient_p font_size_18'>Nutritionist AI</p>
                            <img src={ntai} alt="Nutritionist AI Icon" className='ntai_icon' />
                        </div>
                        <h1>Your Personal Nutrition <span className='green_gradient_p_animated'>Guide</span></h1>
                        <p className='gray_scale_2 font_size_20 font_weight_400'>Unlock expert advice tailored just for you. Whether you have questions about your diet, need meal recommendations, or want to optimize your nutrition, our AI-powered guide is here to support your journey to better health.</p>
                    </div>

                    <div>
                        <img src={img} className='ntai_image' />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NTAI;
